// import { Pagination } from "../../../components/pagination/Pagination";
import moment from "moment";
import { Pagination } from "../../components/pagination/Pagination";
import Table from "../../components/Table/Table";
import Modal from "../../components/Modal";
import useAssignStock from "./hook/useAssignStock";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import MultipleSelect from "../../components/MultipleSelect";
import DateInput from "../../components/DateInput";

import {
  Button,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from "@mui/material";
import TextFields from "../../components/TextField";
import { useNavigate } from "react-router-dom";

const AssignInventory = () => {
  const { data, methods } = useAssignStock();

  const {
    controller,
    totalCount,
    assignStockList,
    uassignModal,
    formData,
    employeeList,
    filter,
  } = data;
  const {
    handlePagination,
    handleCloseModal,
    handleOpenModal,
    handleChange,
    unAssignStock,
    handleFilterChange,
    setFilter,
    handleSearchFilter,
    handleResetFilter,
  } = methods;

  const TableHead = [
    { label: "#", id: "" },
    // { label: "Product Name", id: "product" },
    { label: "Employee Name", id: "name" },
    { label: "Date", id: "date" },
    { label: "Assign/Use Quantity", id: "quantity" },
    { label: "Remarks", id: "remarks" },
    { label: "Status", id: "status" },
    { label: "Type Of Assign/Use", id: "typeOfAssign" },
    { label: "Action", id: "action" },
  ];

  const statusType = [
    { name: "ASSIGN", id: "ASSIGN" },
    { name: "USE", id: "USE" },
    { name: "UNASSIGN", id: "UNASSIGN" },
    { name: "NOTINUSE", id: "NOTINUSE" },
  ];
  const navigate = useNavigate();

  const handleHistory = (id) => {
    navigate(`/inventory/inventory-history/${id}`);
  };
  return (
    <div>
      <div className="d-flex gap-3 mx-3 align-items-end">
        <div className="pt-2" style={{ width: "210px" }}>
          <MultipleSelect
            label="Employee"
            options={employeeList.map((item) => ({
              id: item._id,
              name: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
            }))}
            searchBy="name"
            keyName="name"
            name="employee_id"
            value="id"
            selectedValues={
              filter.employee_id
                ? [
                    {
                      id: filter.employee_id,
                      name:
                        employeeList.find((x) => x._id === filter.employee_id)
                          ?.name || "",
                    },
                  ]
                : []
            }
            onChange={(selected) => {
              const newValue = selected.length > 0 ? selected[0].id : "";
              setFilter((prev) => ({
                ...prev,
                employee_id: newValue,
              }));
            }}
          />
        </div>

        <div className="col-lg-11 pt-2" style={{ width: "210px" }}>
          {/* <DateInput
            size="small"
            variant="outlined"
            className="w-100 form-field-design"
            Label={"Start Date"}
            SelectedDate={filter?.startDateTime || null}
            handleDateChange={handleFilterChange}
          /> */}
          <DateInput
            Label="Start Date"
            SelectedDate={filter?.startDateTime || null}
            handleDateChange={(date) =>
              handleFilterChange("startDateTime", date)
            }
          />
        </div>
        <div className="col-lg-11 pt-2" style={{ width: "210px" }}>
          {/* <DateInput
            size="small"
            variant="outlined"
            className="w-100 form-field-design"
            Label={"End Date"}
            SelectedDate={filter.endDateTime || null}
            handleDateChange={handleFilterChange}
          /> */}
          <DateInput
            Label="End Date"
            SelectedDate={filter?.endDateTime || null}
            handleDateChange={(date) => handleFilterChange("endDateTime", date)}
          />
        </div>
        <div className="pt-2" style={{ width: "210px" }}>
          <MultipleSelect
            label="Status"
            options={statusType.map((item) => ({
              id: item.id,
              name: item.name,
            }))}
            searchBy="name"
            keyName="name"
            name="type"
            value="id"
            selectedValues={
              filter.type
                ? [
                    {
                      id: filter.type,
                      name:
                        statusType.find((x) => x.id === filter.type)?.name ||
                        "",
                    },
                  ]
                : []
            }
            onChange={(selected) => {
              const newValue = selected.length > 0 ? selected[0].id : "";
              setFilter((prev) => ({
                ...prev,
                type: newValue,
              }));
            }}
          />
        </div>
        <div className="pt-2 d-flex gap-2">
          <Button
            variant="contained"
            color="primary"
            style={{ height: "35px" }}
            onClick={handleSearchFilter}
          >
            Search
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            style={{ height: "35px" }}
            onClick={handleResetFilter}
          >
            Reset
          </Button>
        </div>
      </div>
      <div className="mt-2">
        <table className="table">
          <Table TableHeadData={TableHead} rowCount={TableHead?.length} />
          <tbody>
            {assignStockList?.map((item, index) => {
              return (
                <tr
                  className="text-start rounded-row "
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#fff",
                  }}
                >
                  <td className="table-link">
                    {controller.rowsPerPage * (controller.page - 1) + index + 1}{" "}
                  </td>
                  {/* <td className="" >{item?.inventory_id?.productName}</td> */}
                  <td>{item?.employee_id?.firstName}</td>
                  <td>{moment(item?.dateOfAssign).format("YYYY-MM-DD")}</td>
                  <td className="">{item?.assignQuantity}</td>
                  <td className="">{item?.remarks}</td>
                  <td className="">{item?.type}</td>
                  <td className="">{item?.typeOfAssign}</td>
                  <td>
                    <div className="dropdown p-0 align-items-center justify-content-center">
                      <i
                        className="fas fa-ellipsis-v pointer p-2"
                        id="dropdownMenuLink"
                        data-bs-toggle={"dropdown"}
                        // data-bs-toggle={
                        //   item.type === "UNASSIGN" ||
                        //   item.type === "NOTINUSE" ||
                        //   item.isStatusChange === true
                        //     ? ""
                        //     : "dropdown"
                        // }
                        aria-expanded="false"
                        style={{
                          cursor:
                            item.type === "UNASSIGN" ||
                            item.type === "NOTINUSE" ||
                            item.isStatusChange === true
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <li
                          onClick={() =>
                            handleOpenModal(item._id, item.type, item)
                          }
                          style={{ cursor: "pointer" }}
                          className="dropdown-item"
                        >
                          {item.type === "ASSIGN"
                            ? "Unassign Item"
                            : item.type === "USE"
                            ? "Mark Unused"
                            : ""}
                        </li>
                        <li
                          onClick={() => handleHistory(item._id)}
                          style={{ cursor: "pointer" }}
                          className="dropdown-item"
                        >
                          History
                        </li>
                      </ul>
                    </div>
                    {/* )} */}
                  </td>
                </tr>
              );
            })}

            <td colSpan={"20"}>
              {totalCount > 10 && (
                <Pagination
                  style={{ backgroundColor: "#fff" }}
                  count={totalCount}
                  controller={controller}
                  setController={handlePagination}
                />
              )}
            </td>
          </tbody>
        </table>
      </div>

      <Modal
        size="md"
        show={uassignModal}
        onHide={handleCloseModal}
        headerContent={<h5>Unassign</h5>}
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Quantity"
                  Name="quantity"
                  type="number"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.quantity}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="Remark"
                  Name="remarks"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.remarks}
                  width={100}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={handleCloseModal}>
                cancel
              </Button>
              <Button
                onClick={unAssignStock}
                variant="contained"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Confirm
              </Button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default AssignInventory;
